export default __webpack_public_path__ + "static/media/Crowcackle Leggings.239767c0.jpg";